export default __webpack_public_path__ + "static/media/shopping-d-2.145b0b21.png";